import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69bbfdd37d947e0014a3ee4f/localmatch/src/app/locaux/nouveau/page.tsx");
